import { API_URL } from "@/redux-client/api";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import Notification from "../common/Notification";
import Loading from "../common/Loading";

const OverviewCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const [totalBookings, setTotalBookings] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalAgents, setTotalAgents] = useState(0);

  const fetchData = useCallback(async () => {
    const response = await axios.get(
      `${API_URL}/dashboard/overview-total-report`
    );

    const { data, status, msg } = response.data;

    try {
      if (status === 200) {
        const { totalBookings, totalAgents, totalCustomers } = data;
        setTotalBookings(totalBookings);
        setTotalAgents(totalAgents);
        setTotalCustomers(totalCustomers);
        setIsLoading(false);
      } else {
        setNotification({
          title: "Terjadi kesalahan",
          text: msg,
          isError: true,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setNotification({
        title: "Network error!",
        text: "Terjadi kesalahan. Silahkan coba beberapa saat lagi.",
        isError: true,
      });
    }
  }, []);

  useEffect(() => {
    fetchData();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
      <Notification notification={notification} className="mt-2 md:col-span-3" />
      <div className="p-4 bg-white rounded-xl ">
        <p className="text-md">Total Penjualan Tahun {new Date().getFullYear()}</p>
        <hr className="mt-2" />
        {isLoading ? 
          <div className="p-4 mt-4">
            <Loading type="beat-loader" loading={isLoading} size={12} />
          </div>
          : <>
            <p className="font-bold text-4xl mt-4">{totalBookings.lastYear}</p>
          </>
        }
      </div>
      <div className="p-4 bg-white rounded-xl ">
        <p className="text-md">Total Customer</p>
        <hr className="mt-2" />
        {isLoading ? 
          <div className="p-4 mt-4">
            <Loading type="beat-loader" loading={isLoading} size={12} />
          </div>
          : <>
            <p className="font-bold text-4xl mt-4">{totalCustomers} <small className="font-normal">orang</small></p>
          </>
        }
      </div>
      <div className="p-4 bg-white rounded-xl ">
        <p className="text-md">Total Agent</p>
        <hr className="mt-2" />
        {isLoading ? 
          <div className="p-4 mt-4">
            <Loading type="beat-loader" loading={isLoading} size={12} />
          </div>
          : <>
            <p className="font-bold text-4xl mt-4">{totalAgents} <small className="font-normal">orang</small></p>
          </>
        }
      </div>
    </div>
  );
};

export default OverviewCard;
